import React from 'react';

import { getMemoryType } from '../../helpers/memory';

import type { Timeline } from '../../types/timeline';

const TimelineType: React.FC<{ timeline: Timeline }> = ({ timeline }) => {
  return (
    <div className="memory-type">
      <div className="page-eyebrow">
        <i className={`fa-solid fa-${getMemoryType(timeline.type)?.icon}`} />
        {getMemoryType(timeline.type)?.label} - {timeline.lgcy_type} LGCY timeline
      </div>
    </div>
  );
}

export default TimelineType;
